import React from 'react';
const RadioUncheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <circle cx={12} cy={12} r={6.857} stroke="#CFCFCF" strokeWidth={2.286} />
  </svg>
);

export default RadioUncheckedIcon;
